import { motion, useScroll, useTransform, useVelocity, useSpring } from "framer-motion";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { useT } from "@/i18n/LanguageContext";
import ResponsiveArt from "@/components/ResponsiveArt";

const WORKS = [
  { id: "w016", slug: "sunset-doesnt-owe-you-quiet", title: "Sunset Doesn't Owe You Quiet", year: "2026", medium: "Acrylic on canvas", size: "88.9 × 106.68 cm", img: "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/ik0xqx5o_016%20LR.jpg", col: "left" },
  { id: "wDepths", slug: "arising-from-the-depths", title: "Arising from the Depths", year: "2025", medium: "Mixed media on paper", size: "64 × 50 cm", img: "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/l2ui13ns_Arising%20from%20the%20Depths%2C%202025.jpg", col: "left" },
  {
    id: "w003-skin",
    slug: "passage-through",
    title: "Passage Through",
    year: "2025",
    medium: "Acrylic on canvas",
    size: "38 × 53 cm",
    img: "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/8fr4qmvv_IMG_4141.jpg",
    col: "left",
  },
  {
    id: "wCombustion",
    slug: "the-axis-holds",
    title: "The Axis Holds",
    year: "2026",
    medium: "Acrylic on canvas",
    size: "47 × 56 cm",
    img: "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/s88km12u_Image.jpg",
    col: "right",
  },
  {
    id: "wRoots",
    slug: "roots-of-transformation",
    title: "Roots of Transformation",
    year: "2025",
    medium: "Acrylic on canvas",
    size: "30 × 30 cm",
    img: "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/5lzanghr_IMG_4638_zevhjr_upscaled.jpg",
    col: "right",
  },
  {
    id: "w21",
    slug: "nothing-to-prove",
    title: "Nothing to Prove",
    year: "2026",
    medium: "Acrylic on paper",
    size: "64 × 50 cm",
    img: "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/di3d5hq0_021%20LR.jpg",
    col: "left",
  },
  {
    id: "w22",
    slug: "what-the-day-said-before-it-left",
    title: "What the Day Said Before It Left",
    year: "2026",
    medium: "Acrylic on paper",
    size: "64 × 50 cm",
    img: "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/j4xpupqv_022%20LR.jpg",
    col: "right",
  },
  {
    id: "w1",
    slug: "the-skin-stops-lying",
    title: "The Skin Stops Lying",
    year: "2026",
    medium: "Acrylic on paper",
    size: "64 × 50 cm",
    img: "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/elqe1yil_001%20LR.jpg",
    col: "left",
  },
  {
    id: "w4",
    slug: "i-kept-saying-yes",
    title: "I Kept Saying Yes",
    year: "2025",
    medium: "Acrylic on paper",
    size: "64 × 50 cm",
    img: "https://customer-assets.emergentagent.com/job_immersion-studio/artifacts/3fxejt5i_004%20LR.jpg",
    col: "right",
  },
  {
    id: "wLightStayed",
    slug: "when-the-light-stayed",
    title: "When The Light Stayed",
    year: "2025",
    medium: "Acrylic on paper",
    size: "80 × 80 cm",
    img: "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/aioxc45d_When%20The%20Light%20Stayed%2C%202025.jpg",
    col: "right",
  },
  {
    id: "w2026_01",
    slug: "primordial-awakening",
    title: "Primordial Awakening",
    year: "2025",
    medium: "Mixed media on canvas",
    size: "30 × 30 cm",
    img: "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/j2squ5xq_Screenshot%202026-04-18%20at%2022.33.11.png",
    col: "left",
  },
  {
    id: "w2026_02",
    slug: "the-icy-mirror-within",
    title: "The Icy Mirror Within",
    year: "2025",
    medium: "Mixed media on canvas",
    size: "30 × 30 cm",
    img: "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/o925it3v_Screenshot%202026-04-18%20at%2022.33.42.png",
    col: "right",
  },
  {
    id: "w014",
    slug: "im-in-here-somewhere",
    title: "I'm In Here Somewhere",
    year: "2025",
    medium: "Acrylic on paper",
    size: "64 × 50 cm",
    img: "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/nl9wdoqo_014%20LR.jpg",
    col: "left",
  },
  {
    id: "w2026_09",
    slug: "tapni",
    title: "Tapni",
    year: "2025",
    medium: "Acrylic on canvas",
    size: "40 × 40 cm",
    img: "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/t44mi11x_IMG_6313_isnmhc.jpeg",
    col: "right",
  },
  {
    id: "w2026_12",
    slug: "eye-of-enlightenment",
    title: "Eye of Enlightenment",
    year: "2024",
    medium: "Acrylic on canvas",
    size: "152.4 × 121.92 cm",
    img: "https://customer-assets.emergentagent.com/job_d1c1e8f3-af7e-4791-90a6-1b161090eb05/artifacts/b5jr5snj_Screenshot%202026-05-20%20at%2022.18.50.png",
    col: "left",
  },
];

function Plate({ work, index, velocity }) {
  const { t } = useT();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  // Scroll-velocity shear — plates skew & blur subtly when scrolling fast,
  // then settle. Clamped so it's felt, not flashy.
  const skew = useTransform(velocity, [-3000, 0, 3000], [-2.4, 0, 2.4]);
  const blur = useTransform(velocity, [-4000, -1200, 0, 1200, 4000], [1.2, 0.3, 0, 0.3, 1.2]);
  const filter = useTransform(blur, (b) => `blur(${b}px)`);
  const isLeft = index % 2 === 0;
  const target = work.slug ? `/works/${work.slug}` : "/works";

  return (
    <div
      ref={ref}
      data-testid={`work-${work.id}`}
      className={`relative flex flex-col ${
        isLeft ? "md:items-start" : "md:items-end"
      } w-full mb-[10vh] md:mb-[12vh]`}
    >
      <div className={`w-full md:w-fit md:max-w-[58%] ${isLeft ? "md:ml-[5%]" : "md:mr-[5%]"} relative`}>
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="flex justify-between items-end mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-ink/70"
        >
          <span>№ {String(index + 1).padStart(2, "0")}</span>
          <span>{work.year}</span>
        </motion.div>

        <Link to={target} data-cursor="view" className="block">
          <motion.div
            style={{ y, skewY: skew, filter }}
            whileHover={{ scale: 1.01 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="relative overflow-hidden bg-bone group inline-block"
          >
            <ResponsiveArt
              src={work.img}
              alt={work.title}
              sizes="(min-width: 768px) 58vw, 100vw"
              eager={index < 2}
              fadeIn={false}
              className="art-img block max-w-full max-h-[88vh] w-auto h-auto"
              onImg={(attrs) => (
                <motion.img
                  {...attrs}
                  initial={{ scale: 1.15 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true, margin: "-50px" }}
                  transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
                  whileHover={{ scale: 1.05 }}
                />
              )}
            />
            <motion.div
              initial={{ opacity: 0 }}
              whileHover={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="absolute inset-0 flex items-end justify-start p-6 bg-gradient-to-t from-ink/70 via-ink/0 to-transparent pointer-events-none"
            >
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-bone">
                Look closer ↗
              </span>
            </motion.div>
          </motion.div>
        </Link>

        <div className="mt-5">
          <div className="flex flex-wrap items-baseline gap-x-5 gap-y-1">
            <motion.h3
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
              className="font-serif text-3xl md:text-4xl leading-tight"
            >
              {work.title}
            </motion.h3>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink/70">
              {[work.medium, work.size].filter(Boolean).join(" · ")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Showcase() {
  const { t } = useT();
  // Track scroll velocity once at the section level, share it with every Plate
  // so the skew/blur feels coherent across the page (not per-plate jitter).
  const { scrollY } = useScroll();
  const rawVelocity = useVelocity(scrollY);
  const velocity = useSpring(rawVelocity, { stiffness: 120, damping: 22, mass: 0.4 });

  return (
    <section id="works" data-testid="works-section" className="relative w-full bg-bone pt-[12vh] pb-[8vh]">
      <div className="px-6 md:px-10 mb-[8vh]">
        <div className="flex items-end justify-between border-b border-ink/30 pb-6">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase">{t("showcase.eyebrow")}</p>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase">{t("showcase.scroll")}</p>
        </div>
        <motion.h2
          initial={{ y: 60, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="mt-8 font-serif font-black uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.88] tracking-tighter max-w-5xl"
        >
          {t("showcase.headline_pre")} <em className="font-serif italic font-normal text-crimson">{t("showcase.headline_emph")}</em>.
        </motion.h2>
      </div>

      <div className="px-2 md:px-0">
        {WORKS.map((w, i) => (
          <Plate key={w.id} work={w} index={i} velocity={velocity} />
        ))}
      </div>

      <div className="px-6 md:px-10 mt-[8vh] flex justify-between items-center border-t border-ink/30 pt-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink/70">
          {t("showcase.more_archive")}
        </p>
        <Link
          to="/works"
          data-testid="view-archive"
          data-cursor="hover"
          data-magnetic
          className="font-mono text-[11px] uppercase tracking-[0.3em] link-underline"
        >
          {t("showcase.open_archive")}
        </Link>
      </div>
    </section>
  );
}
